

require('xo-ui-components/src/tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoDobNationalid', function () {
    var padNumber = function padNumber(num) {
        return num.toString().replace(/^(\d)$/, '0$1');
    };
    /**
     * Create an array from a start and end number.
     * @param  {Number} start
     * @param  {Number} end
     * @return {Array}
     */
    var getRange = function getRange(start, end) {
        var arr = [];
        // decide how this array shall be sorted

        if (start < end) {
            for (; start <= end; start++) {
                arr.push(padNumber(start));
            }
        } else {
            for (; start >= end; start--) {
                arr.push(padNumber(start));
            }
        }
        return arr;
    };

    return {
        template: _template2['default'],
        scope: {
            pi: '=?'
        },

        controller: ['$scope', function ($scope) {

            $scope.init = function () {
                var thisYear = new Date().getFullYear();

                $scope.days = getRange(1, 31);
                $scope.months = getRange(1, 12);
                $scope.years = getRange(thisYear - 18, thisYear - 110);
            };
            $scope.init();
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-form-components/src/dob-nationalid/directive.js
// module id = ../node_modules/xo-form-components/src/dob-nationalid/directive.js
// module chunks = 0